<div *ngIf="(dataloader.isLoading$ | async)">
    <div class="loader" role="status">
        <span class="visually-hidden">Loading...
            <span class="spinner-border-sm" aria-hidden="true"></span>
        </span>
    </div>
    <div id="overlay" class="overlay"></div>
</div>